import React, { useState, useEffect } from 'react';
import './DuelPage.css';
import { loadDeckFromStorage } from '../logic/DuelLogic';
import { handleDeckAction } from '../logic/DuelLogic';
import ZoneSlot from '../components/ZoneSlot';
import HandCard from '../components/HandCard';
import AllModals from '../components/AllModals';
import { playSound } from '../utils/soundPlayer';
import { useParams } from 'react-router-dom';
import { db, doc, getDoc, updateDoc, onSnapshot, serverTimestamp } from '../firebase';
import { getAuth } from 'firebase/auth';
import PvpSlot from '../components/PvpSlot'; // ✅ Online-compatible slot
import cardBackImage from '../assets/images/card-back.jpg';
import { toast } from 'react-toastify';







const PvpOnline = () => {
  const [roomStatus, setRoomStatus] = useState('');
  const [mainDeck, setMainDeck] = useState([]);
  const [extraDeck, setExtraDeck] = useState([]);
  const [sideDeck, setSideDeck] = useState([]);
  const [hand, setHand] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [fieldMap, setFieldMap] = useState({});
  const [showDeckMenu, setShowDeckMenu] = useState(false);
  const [deckMenuPosition, setDeckMenuPosition] = useState({ top: 0, left: 0 });
  const [showDeckModal, setShowDeckModal] = useState(false);
  const [myGYZ, setMyGYZ] = useState([]);  // instead of null
  const [myBZ, setMyBZ] = useState([]);
  const [viewZoneCards, setViewZoneCards] = useState([]);
  const [zoneViewerTitle, setZoneViewerTitle] = useState('');
  const [handMenuCard, setHandMenuCard] = useState(null);
  const [pendingSummon, setPendingSummon] = useState(null);
  const [pendingNormalSummon, setPendingNormalSummon] = useState(null);
  const [summonPosition, setSummonPosition] = useState('ATK');
  const [revealCard, setRevealCard] = useState(null);
  const [revealTitle, setRevealTitle] = useState('');
  const [pendingSTPlacement, setPendingSTPlacement] = useState(null);
  const [showExtraMenu, setShowExtraMenu] = useState(false);
  const [extraCardModalCard, setExtraCardModalCard] = useState(null);
  const [pendingExtraSummon, setPendingExtraSummon] = useState(null);
  const [extraSummonPosition, setExtraSummonPosition] = useState('ATK');
  const [pendingFieldMove, setPendingFieldMove] = useState(null);
  const [pendingFieldPlacement, setPendingFieldPlacement] = useState(null);
  const [zoneCardModal, setZoneCardModal] = useState(null);
  const [pendingOverlay, setPendingOverlay] = useState(null);
  const [pendingSSATKHand, setPendingSSATKHand] = useState(null);
  const [pendingSSDEFHand, setPendingSSDEFHand] = useState(null);
  const [pendingSetMonsterHand, setPendingSetMonsterHand] = useState(null);
  const [hasLoadedFromFirestore, setHasLoadedFromFirestore] = useState(false);
  const [opponentMainDeck, setOpponentMainDeck] = useState([]);
  const [opponentExtraDeck, setOpponentExtraDeck] = useState([]);


  const [isGameStateLoaded, setIsGameStateLoaded] = useState(false);

  const [pendingToken, setPendingToken] = useState(false);
  const { roomId } = useParams();
  const syncGameState = async (updatedPartialState) => {
    if (!roomId || !playerRole) return;

    const roomRef = doc(db, 'duelRooms', roomId);

    try {
      const snap = await getDoc(roomRef);
      const roomData = snap.data();

      if (!roomData?.gameState || !roomData.gameState[playerRole]) {
        return;
      }

      const previousState = roomData.gameState[playerRole];

      await updateDoc(roomRef, {
        [`gameState.${playerRole}`]: {
          ...previousState,
          ...updatedPartialState,
          isInitialized: true // ✅ force flag at root of host/guest

        },
        'gameState.updatedAt': serverTimestamp()
      });

    } catch (err) {
    }
  };





  const user = getAuth().currentUser;
  const [playerRole, setPlayerRole] = useState(undefined); // undefined works better for presence check
  const [opponentFieldMap, setOpponentFieldMap] = useState({});
  const [opponentHand, setOpponentHand] = useState([]);
  const [opponentGY, setOpponentGY] = useState([]);
  const [opponentBZ, setOpponentBZ] = useState([]);
  const [opponentActionMessage, setOpponentActionMessage] = useState('');

  const getRenderedZone = (logicalLabel) => {
    if (!playerRole || logicalLabel === '') return '';
    const [owner, zone] = logicalLabel.split('.');
    const isMine = playerRole === 'host' ? owner === 'host' : owner === 'guest';
    return `${isMine ? 'My' : 'Opp'} ${zone}`;
  };




  const resetAllPendingStates = () => {
    setPendingSummon(null);
    setPendingNormalSummon(null);
    setPendingSTPlacement(null);
    setPendingFieldPlacement(null);
    setPendingExtraSummon(null);
    setPendingFieldMove(null);
    setPendingOverlay(null);
    setPendingSSATKHand(null);
    setPendingSSDEFHand(null);


  };

  useEffect(() => {
    const auth = getAuth();
    let unsubscribe;

    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      if (!user || !roomId) return;

      const roomRef = doc(db, 'duelRooms', roomId);
      const snapshot = await getDoc(roomRef);
      const roomData = snapshot.data();

      if (!roomData) return;

      const isHost = roomData.hostUid === user.uid;
      const myRole = isHost ? 'host' : 'guest';
      const opponentRole = isHost ? 'guest' : 'host';

      setPlayerRole(myRole);

      // ✅ Initialize gameState if host and not set
      if (isHost && !roomData.gameState) {
        const gameState = {
          host: {
            mainDeck,
            extraDeck,
            hand,
            fieldMap,
            gy: myGYZ,
            bz: myBZ
          },
          guest: {
            mainDeck: [],
            extraDeck: [],
            hand: [],
            fieldMap: {},
            gy: [],
            bz: []
          },
          turn: 'host',
          updatedAt: serverTimestamp()
        };

        await updateDoc(roomRef, { gameState });
      }


      unsubscribe = onSnapshot(roomRef, (snap) => {
        const data = snap.data();
        if (!data?.gameState) {
          return;
        }
        setRoomStatus(data.status || '');

        const state = data.gameState[myRole] ?? {};
        const opponentState = data.gameState[opponentRole] ?? {};


        // ✅ Only update if values exist to avoid overwriting good state
        if (state.mainDeck) setMainDeck(state.mainDeck);
        if (state.extraDeck) setExtraDeck(state.extraDeck);
        if (state.hand) setHand(state.hand);
        if (state.gy) setMyGYZ(state.gy);
        if (state.bz) setMyBZ(state.bz);
        if (state.fieldMap) setFieldMap(state.fieldMap);

        // ✅ Set sync/ready flags AFTER state is updated
        setIsGameStateLoaded(true);
        setHasLoadedFromFirestore(true);

        // 🧠 Opponent logic
        if (opponentState) {
          // ✅ Set opponent decks
          setOpponentMainDeck(opponentState.mainDeck || []);
          setOpponentExtraDeck(opponentState.extraDeck || []);
          const summon = Object.entries(opponentState.fieldMap || {}).find(
            ([zoneLabel, zoneData]) =>
              zoneLabel.includes('MZ') &&
              zoneData?.from === 'hand' &&
              !zoneData.card?.isFaceDown
          );
          if (opponentState.hand) {
            const anonymizedHand = opponentState.hand.map((card, i) => ({
              id: `opponent-fd-${i}`,
              isFaceDown: true
            }));
            setOpponentHand(anonymizedHand);
          }


          if (summon) {
            setOpponentActionMessage('Opponent summoned a monster from hand!');
            setTimeout(() => setOpponentActionMessage(''), 3000);
          }

          const filteredFieldMap = {};
          const transformedOpponentFieldMap = {};
          for (const zone in opponentState.fieldMap || {}) {
            const zoneData = opponentState.fieldMap[zone];

            const displayLabel =
              zone.startsWith('My ')
                ? zone.replace('My ', 'Opp ') // Their "My MZ1" becomes our "Opp MZ1"
                : zone;

            transformedOpponentFieldMap[displayLabel] = {
              ...zoneData,
              card: zoneData.card?.isFaceDown
                ? { name: 'Face-down', isFaceDown: true }
                : zoneData.card
            };
          }
          setOpponentFieldMap(transformedOpponentFieldMap);
          //setOpponentFieldMap(filteredFieldMap);
          setOpponentGY(opponentState.gy || []);
          setOpponentBZ(opponentState.bz || []);

        }
      });

    });


    return () => {
      unsubscribeAuth();
      if (unsubscribe) unsubscribe();
    };
  }, []);

  useEffect(() => {
  }, [opponentHand]);

  useEffect(() => {
    const deckData = loadDeckFromStorage();
    const currentUID = localStorage.getItem('uid');

    if (!deckData || !playerRole || !roomId || !currentUID) return;

    const roomRef = doc(db, 'duelRooms', roomId);

    const syncIfEmpty = async () => {
      const snapshot = await getDoc(roomRef);
      const roomData = snapshot.data();
      const playerKey = playerRole;

      const handFromFirestore = roomData?.gameState?.[playerKey]?.hand;
      if (!handFromFirestore || handFromFirestore.length === 0) {
        // ✅ Sync localStorage to Firestore
        setMainDeck(deckData.main);
        setExtraDeck(deckData.extra);
        setSideDeck(deckData.side);
        setHand(deckData.hand);

        await updateDoc(roomRef, {
          [`gameState.${playerKey}.mainDeck`]: deckData.main,
          [`gameState.${playerKey}.extraDeck`]: deckData.extra,
          [`gameState.${playerKey}.hand`]: deckData.hand,
          [`gameState.${playerKey}.gy`]: [],
          [`gameState.${playerKey}.bz`]: [],
          [`gameState.${playerKey}.fieldMap`]: {},
          [`gameState.${playerKey}.isInitialized`]: true,
          [`gameState.updatedAt`]: serverTimestamp(),
        });

      } else {
        // ✅ Load existing state from Firestore
        const playerState = roomData.gameState[playerKey];

        setMainDeck(playerState.mainDeck || []);
        setExtraDeck(playerState.extraDeck || []);
        setSideDeck(playerState.sideDeck || []);
        setHand(playerState.hand || []);
        setMyGYZ(playerState.gy || []);
        setMyBZ(playerState.bz || []);
        setFieldMap(playerState.fieldMap || {});
      }

    };

    syncIfEmpty();
  }, [playerRole, roomId]);



  useEffect(() => {
    if (!playerRole || !roomId || !hand) return;
    const roomRef = doc(db, 'duelRooms', roomId);
    updateDoc(roomRef, {
      [`gameState.${playerRole}.hand`]: hand
    });
  }, [hand]);
  useEffect(() => {
    if (!playerRole || !roomId || !myGYZ) return;

    const roomRef = doc(db, 'duelRooms', roomId);
    updateDoc(roomRef, {
      [`gameState.${playerRole}.gy`]: myGYZ
    });
  }, [myGYZ]);

  useEffect(() => {
    if (!playerRole || !roomId || !myBZ) return;

    const roomRef = doc(db, 'duelRooms', roomId);
    updateDoc(roomRef, {
      [`gameState.${playerRole}.bz`]: myBZ
    });
  }, [myBZ]);

  useEffect(() => {
    if (!playerRole || !roomId || !fieldMap) return;

    const roomRef = doc(db, 'duelRooms', roomId);
    updateDoc(roomRef, {
      [`gameState.${playerRole}.fieldMap`]: fieldMap
    });
  }, [fieldMap]);








  // useEffect(() => {
  //   const deckData = loadDeckFromStorage();
  //   if (deckData) {
  //     setMainDeck(deckData.main);
  //     setExtraDeck(deckData.extra);
  //     setSideDeck(deckData.side);
  //     setHand(deckData.hand);
  //   }
  // }, []);


  const baseLogicalGrid = [
    ['host.Deck', 'host.GYZ', 'host.BZ', 'guest.FZ', 'guest.Extra'],
    ['host.STZ5', 'host.MZ5', '', 'guest.MZ1', 'guest.STZ1'],
    ['host.STZ4', 'host.MZ4', 'EXMZ1', 'guest.MZ2', 'guest.STZ2'],
    ['host.STZ3', 'host.MZ3', 'TOKEN_BUTTON', 'guest.MZ3', 'guest.STZ3'],
    ['host.STZ2', 'host.MZ2', 'EXMZ2', 'guest.MZ4', 'guest.STZ4'],
    ['host.STZ1', 'host.MZ1', '', 'guest.MZ5', 'guest.STZ5'],
    ['host.Extra', 'host.FZ', 'guest.BZ', 'guest.GYZ', 'guest.Deck']
  ];
  const logicalGrid = baseLogicalGrid;




  const handleFieldCardAction = (action, card) => {
    resetAllPendingStates(); // 🧹 prevent leftover actions
    const sendOverlaysToGY = (zone) => {
      const overlays = fieldMap[zone]?.overlays || [];
      if (overlays.length > 0) {
        setMyGYZ(prev => [...prev, ...overlays]);
      }
    };

    const zone = card.zone;
    const isExtra = card.type?.match(/Fusion|Synchro|XYZ|Link/);
    const cardCopy = { ...card };
    // ✅ Always reset face-down state if relevant action
    const resetFaceDownActions = [
      'Move',
      'To Bottom Deck',
      'To Top Deck',
      'Banish',
      'Banish FD',
      'To hand',
      'To Extra',
      'Activate ST',
      'To GY',
      'Flip',
      'Flip Summon'
    ];
    if (cardCopy.isFaceDown && resetFaceDownActions.includes(action)) {
      cardCopy.isFaceDown = false;
    }

    const removeCardFromField = () => {
      setFieldMap(prev => {
        const updated = { ...prev };
        delete updated[zone];
        syncGameState({ fieldMap: updated }); // ✅
        return updated;
      });
    };

    const moveToDeck = (position = 'top') => {
      removeCardFromField();
      if (isExtra) {
        setExtraDeck(prev => position === 'top' ? [cardCopy, ...prev] : [...prev, cardCopy]);
      } else {
        setMainDeck(prev => position === 'top' ? [cardCopy, ...prev] : [...prev, cardCopy]);
      }
    };

    switch (action) {
      case 'To GY':
        playSound('gy');
        sendOverlaysToGY(zone);
        const updatedField = { ...fieldMap };
        delete updatedField[zone];

        const updatedGY = [...myGYZ, ...(fieldMap[zone]?.overlays || []), cardCopy];

        setFieldMap(updatedField);
        setMyGYZ(updatedGY);

        syncGameState({
          fieldMap: updatedField,
          gy: updatedGY
        });

        break;
      case 'Remove': {
        const updatedField = { ...fieldMap };
        delete updatedField[zone];

        setFieldMap(updatedField);

        syncGameState({
          fieldMap: updatedField
        });

        break;
      }


      case 'Banish': {
        playSound('gy');

        const overlays = fieldMap[zone]?.overlays || [];
        const updatedFieldMap = { ...fieldMap };
        delete updatedFieldMap[zone];

        const updatedBZ = [...myBZ, ...overlays, cardCopy];

        setFieldMap(updatedFieldMap);
        setMyBZ(updatedBZ);

        syncGameState({
          fieldMap: updatedFieldMap,
          bz: updatedBZ
        });

        break;
      }


      case 'Banish FD': {
        playSound('gy');

        const overlays = fieldMap[zone]?.overlays || [];
        const updatedFieldMap = { ...fieldMap };
        delete updatedFieldMap[zone];

        cardCopy.isFaceDown = true;
        const updatedBZ = [...myBZ, ...overlays, cardCopy];

        setFieldMap(updatedFieldMap);
        setMyBZ(updatedBZ);

        syncGameState({
          fieldMap: updatedFieldMap,
          bz: updatedBZ
        });

        break;
      }

      case 'To Top Deck':
      case 'To Top Extra': {
        const overlays = fieldMap[zone]?.overlays || [];
        const updatedFieldMap = { ...fieldMap };
        delete updatedFieldMap[zone];

        const updatedGY = [...myGYZ, ...overlays];
        const isExtraCard = cardCopy.type?.match(/Fusion|Synchro|XYZ|Link/);

        if (isExtraCard) {
          const updatedExtraDeck = [cardCopy, ...extraDeck];
          setExtraDeck(updatedExtraDeck);

          syncGameState({
            fieldMap: updatedFieldMap,
            gy: updatedGY,
            extraDeck: updatedExtraDeck
          });
        } else {
          const updatedMainDeck = [cardCopy, ...mainDeck];
          setMainDeck(updatedMainDeck);

          syncGameState({
            fieldMap: updatedFieldMap,
            gy: updatedGY,
            mainDeck: updatedMainDeck
          });
        }

        setFieldMap(updatedFieldMap);
        setMyGYZ(updatedGY);
        break;
      }


      case 'To Bottom Deck':
      case 'To Bottom Extra': {
        const overlays = fieldMap[zone]?.overlays || [];
        const updatedFieldMap = { ...fieldMap };
        delete updatedFieldMap[zone];

        const updatedGY = [...myGYZ, ...overlays];
        const isExtraCard = cardCopy.type?.match(/Fusion|Synchro|XYZ|Link/);

        if (isExtraCard) {
          const updatedExtraDeck = [...extraDeck, cardCopy];
          setExtraDeck(updatedExtraDeck);

          syncGameState({
            fieldMap: updatedFieldMap,
            gy: updatedGY,
            extraDeck: updatedExtraDeck
          });
        } else {
          const updatedMainDeck = [...mainDeck, cardCopy];
          setMainDeck(updatedMainDeck);

          syncGameState({
            fieldMap: updatedFieldMap,
            gy: updatedGY,
            mainDeck: updatedMainDeck
          });
        }

        setFieldMap(updatedFieldMap);
        setMyGYZ(updatedGY);
        break;
      }


      case 'To hand':
      case 'To Extra': {
        const overlays = fieldMap[zone]?.overlays || [];
        const updatedFieldMap = { ...fieldMap };
        delete updatedFieldMap[zone];

        const updatedGY = [...myGYZ, ...overlays];

        let updatedHand = [...hand];
        let updatedExtra = [...extraDeck];

        if (!isExtra) {
          updatedHand.push(cardCopy);
          setHand(updatedHand);
        } else {
          updatedExtra.push(cardCopy);
          setExtraDeck(updatedExtra);
        }

        setFieldMap(updatedFieldMap);
        setMyGYZ(updatedGY);

        syncGameState({
          fieldMap: updatedFieldMap,
          gy: updatedGY,
          hand: updatedHand,
          extraDeck: updatedExtra
        });

        break;
      }
      case 'Set': {
        playSound('set');

        const updatedFieldMap = {
          ...fieldMap,
          [zone]: {
            card: { ...cardCopy, isFaceDown: true },
            position: 'DEF',
            overlays: fieldMap[zone]?.overlays || [],
            from: 'hand'
          }
        };

        // ✅ Remove the card from hand
        const updatedHand = [...hand];
        const handIndex = updatedHand.findIndex(
          (c) => c.id === cardCopy.id || c === cardCopy || c === cardCopy.original
        );
        if (handIndex !== -1) {
          updatedHand.splice(handIndex, 1);
        }

        setFieldMap(updatedFieldMap);
        setHand(updatedHand);

        syncGameState({
          fieldMap: updatedFieldMap,
          hand: updatedHand
        });

        break;
      }


      case 'To DEF': {
        playSound('gy');

        const updatedFieldMap = {
          ...fieldMap,
          [zone]: {
            ...fieldMap[zone],
            position: 'DEF',
            overlays: fieldMap[zone]?.overlays || []
          }
        };

        setFieldMap(updatedFieldMap);

        syncGameState({
          fieldMap: updatedFieldMap
        });

        break;
      }

      case 'To ATK': {
        playSound('gy');

        const updatedFieldMap = {
          ...fieldMap,
          [zone]: {
            ...fieldMap[zone],
            position: 'ATK',
            overlays: fieldMap[zone]?.overlays || []
          }
        };

        setFieldMap(updatedFieldMap);

        syncGameState({
          fieldMap: updatedFieldMap
        });

        break;
      }



      case 'Flip': {
        playSound('gy');

        const updatedFieldMap = {
          ...fieldMap,
          [zone]: {
            ...fieldMap[zone],
            card: { ...cardCopy, isFaceDown: false },
            position: 'DEF',
            overlays: fieldMap[zone]?.overlays || []
          }
        };

        setFieldMap(updatedFieldMap);

        syncGameState({
          fieldMap: updatedFieldMap
        });

        break;
      }


      case 'Flip Summon': {
        playSound('ns');

        const updatedFieldMap = {
          ...fieldMap,
          [zone]: {
            ...fieldMap[zone],
            card: { ...cardCopy, isFaceDown: false },
            position: 'ATK',
            overlays: fieldMap[zone]?.overlays || []
          }
        };

        setFieldMap(updatedFieldMap);

        syncGameState({
          fieldMap: updatedFieldMap
        });

        break;
      }


      case 'Declare':
        setRevealCard(cardCopy);
        setRevealTitle('Effect Declaration');

        break;

      case 'Target':
        setRevealCard(cardCopy);
        setRevealTitle('Target Selected');
        break;

      case 'Activate ST': {
        playSound('act');

        const updatedFieldMap = {
          ...fieldMap,
          [zone]: {
            ...fieldMap[zone],
            card: { ...cardCopy, isFaceDown: false }
          }
        };

        setFieldMap(updatedFieldMap);

        syncGameState({
          fieldMap: updatedFieldMap
        });

        break;
      }


      case 'Xyz Material':
        setPendingOverlay({ ...card, zone }); // Save the overlay material
        break;
      case 'Move':
        setPendingFieldMove({ ...cardCopy, zone });
        //removeCardFromField();
        break;

      default:
        break;
    }

    setSelectedCard(null); // Close modal
    if (action !== 'Xyz Material') {
      setPendingOverlay(null); // Cancel overlay mode unless it's 'Overlay'
    }


  };

  const handleZoneCardAction = (action, card, origin) => {
    resetAllPendingStates();
    const cardCopy = { ...card };
    const isExtra = card.type?.match(/Fusion|Synchro|XYZ|Link/);
    const isMonster = card.type?.includes('Monster');

    // Always reset face-down for reuse
    cardCopy.isFaceDown = false;

    const removeFromZone = () => {
      if (origin === 'GY') {
        setMyGYZ(prev => prev.filter(c => c !== card));
      } else if (origin === 'BZ') {
        setMyBZ(prev => prev.filter(c => c !== card));
      } else if (origin === 'Deck') {
        setMainDeck(prev => prev.filter(c => c !== card.original));
      }
    };

    if (action === 'To Extra') {
      const cardCopy = { ...zoneCardModal.card }; // safer clone
      let newGY = [...myGYZ];
      let newBZ = [...myBZ];
      let updatedExtra = [];

      if (zoneCardModal.origin === 'GY') {
        const index = newGY.findIndex(c => c === zoneCardModal.card || c === zoneCardModal.card.original);
        if (index !== -1) {
          newGY.splice(index, 1);
          setMyGYZ(newGY);
          updatedExtra = [...extraDeck, cardCopy];
          setExtraDeck(updatedExtra);
        }
      } else if (zoneCardModal.origin === 'BZ') {
        const index = newBZ.findIndex(c => c === zoneCardModal.card || c === zoneCardModal.card.original);
        if (index !== -1) {
          newBZ.splice(index, 1);
          setMyBZ(newBZ);
          updatedExtra = [...extraDeck, cardCopy];
          const cleanCard = { ...zoneCardModal.card };
          delete cleanCard.isFaceDown;
          setExtraDeck(prev => [...prev, cleanCard]);
          //setExtraDeck(updatedExtra);
        }
      }

      // ✅ Sync to Firestore
      syncGameState({
        mainDeck,
        extraDeck: updatedExtra.length ? updatedExtra : extraDeck,
        hand,
        gy: newGY,
        bz: newBZ,
        fieldMap,
        roomId,
        playerRole
      });

      setZoneCardModal(null);
    }


    switch (action) {
      case 'To GY':
        playSound('gy');
        removeFromZone();

        const newBZAfterGY = myBZ.filter(c => c !== card && c !== card.original);
        const updatedGYZAfterBZ = [...myGYZ, cardCopy];

        setMyBZ(newBZAfterGY);
        setMyGYZ(updatedGYZAfterBZ);

        syncGameState({
          bz: newBZAfterGY,
          gy: updatedGYZAfterBZ
        });
        break;



      case 'To Bottom Deck':
        playSound('gy');
        removeFromZone();
        const updatedBottomDeck = [...mainDeck, cardCopy];
        setMainDeck(updatedBottomDeck);

        if (origin === 'GY') {
          const newGYZ = myGYZ.filter(c => c !== card && c !== card.original);
          setMyGYZ(newGYZ);
          syncGameState({ mainDeck: updatedBottomDeck, gy: newGYZ });
        } else if (origin === 'BZ') {
          const newBZ = myBZ.filter(c => c !== card && c !== card.original);
          setMyBZ(newBZ);
          syncGameState({ mainDeck: updatedBottomDeck, bz: newBZ });
        }
        break;

      case 'To Top Deck':
        playSound('gy');
        removeFromZone();
        const updatedTopDeck = [cardCopy, ...mainDeck];
        setMainDeck(updatedTopDeck);

        if (origin === 'GY') {
          const newGYZ = myGYZ.filter(c => c !== card && c !== card.original);
          setMyGYZ(newGYZ);
          syncGameState({ mainDeck: updatedTopDeck, gy: newGYZ });
        } else if (origin === 'BZ') {
          const newBZ = myBZ.filter(c => c !== card && c !== card.original);
          setMyBZ(newBZ);
          syncGameState({ mainDeck: updatedTopDeck, bz: newBZ });
        }
        break;



      case 'Banish':
        playSound('gy');
        const newGY_Banish = myGYZ.filter(c => c !== card && c !== card.original);
        removeFromZone();
        const newBZ = [...myBZ, cardCopy];
        setMyBZ(newBZ);
        setMyGYZ(newGY_Banish);
        syncGameState({ bz: newBZ, gy: newGY_Banish });
        break;


      case 'Banish FD':
        playSound('gy');
        const newGY_BanishFD = myGYZ.filter(c => c !== card && c !== card.original);
        removeFromZone();
        const fdCard = { ...cardCopy, isFaceDown: true };
        const updatedBZ = [...myBZ, fdCard];
        setMyBZ(updatedBZ);
        setMyGYZ(newGY_BanishFD);
        syncGameState({ bz: updatedBZ, gy: newGY_BanishFD });
        break;


      case 'To Hand':
        playSound('gy');
        removeFromZone(); // ✅ remove from deck

        const updatedHand = [...hand, { ...cardCopy, origin: 'hand' }];
        const updatedDeck = mainDeck.filter(c => c !== card.original);

        setMainDeck(updatedDeck);
        setHand(updatedHand);

        syncGameState({
          fieldMap,
          hand: updatedHand,
          mainDeck: updatedDeck,
          extraDeck,
          gy: myGYZ,
          bz: myBZ,
          roomId,
          playerRole
        });
        break;




      case 'To S/T':

        removeFromZone(); // ✅ Add this line
        cardCopy.origin = origin;
        cardCopy.original = card; // ✅ Track the original clicked card
        cardCopy.isFaceDown = true;
        setPendingSTPlacement(cardCopy);
        break;

      case 'SS ATK':

        cardCopy.origin = origin; // 🔁 Used later for removal
        cardCopy.original = card; // ✅ track exact card clicked
        setPendingSummon(cardCopy);
        setSummonPosition('ATK');
        break;

      case 'SS DEF':

        cardCopy.origin = origin; // 🔁 Used later for removal
        cardCopy.original = card; // ✅ track exact card clicked
        setPendingSummon(cardCopy);
        setSummonPosition('DEF');
        break;

      case 'SS ATK GY':
        cardCopy.origin = origin;
        cardCopy.original = card;
        setPendingSummon(cardCopy);
        setSummonPosition('ATK');
        break;

      case 'SS DEF GY':
        cardCopy.origin = origin;
        cardCopy.original = card;
        setPendingSummon(cardCopy);
        setSummonPosition('DEF');
        break;


      case 'Declare':
        setRevealCard(cardCopy);
        setRevealTitle('Effect Declaration');
        break;

      case 'Target':
        setRevealCard(cardCopy);
        setRevealTitle('Target Selected');
        break;

      default:
        break;
    }

    setZoneCardModal(null); // ✅ Close the modal
    setViewZoneCards([]);
  };




  const onDeckAction = (action) => {
    if (action === 'View') {
      setViewZoneCards(mainDeck);
      setZoneViewerTitle('Deck');
      return;
    }

    if (action === 'Banish FD') {
      if (mainDeck.length === 0) return;

      const topCard = mainDeck[mainDeck.length - 1];
      const newDeck = mainDeck.slice(0, -1);
      const newBZ = [...myBZ, { ...topCard, isFaceDown: true }];

      setMainDeck(newDeck);
      setMyBZ(newBZ);

      // ✅ Sync both deck and BZ
      syncGameState({
        mainDeck: newDeck,
        bz: newBZ
      });

      return;
    }



    // 👇 Other actions like Mill, Shuffle, Draw
    handleDeckAction({
      action,
      mainDeck,
      setMainDeck,
      setHand,
      setMyBZ,
      setMyGYZ,
      hand,
      extraDeck,
      myGYZ,
      myBZ,
      roomId,
      playerRole,
      fieldMap
    });
  };


  const handleExtraDeckAction = (action) => {
    if (action === 'View') {
      setViewZoneCards(extraDeck);
      setZoneViewerTitle('Extra Deck');
      return;
    }

    if (action === 'Shuffle') {
      playSound('shuffle');
      const shuffled = [...extraDeck].sort(() => Math.random() - 0.5);
      setExtraDeck(shuffled);

      // ✅ Sync updated extraDeck
      syncGameState({
        extraDeck: shuffled,
        mainDeck,
        hand,
        gy: myGYZ,
        bz: myBZ,
        fieldMap,
        roomId,
        playerRole
      });
      return;
    }

    if (action === 'Banish FD') {
      playSound('bz');
      if (extraDeck.length === 0) return;

      const topCard = extraDeck[extraDeck.length - 1];
      const newExtraDeck = extraDeck.slice(0, -1);
      const newBZ = [...myBZ, { ...topCard, isFaceDown: true }];

      setExtraDeck(newExtraDeck);
      setMyBZ(newBZ);

      // ✅ Sync both updated extraDeck and bz
      syncGameState({
        extraDeck: newExtraDeck,
        bz: newBZ,
        mainDeck,
        hand,
        gy: myGYZ,
        fieldMap,
        roomId,
        playerRole
      });
    }
  };

  const handleExtraCardAction = (action) => {
    resetAllPendingStates(); // 🧹 clear old pending extra summons

    if (!extraCardModalCard) return;

    const updatedExtraDeck = extraDeck.filter(c => c !== extraCardModalCard);
    let updatedBZ = [...myBZ];
    let updatedGY = [...myGYZ];

    if (action === 'Reveal') {
      setRevealCard(extraCardModalCard);
      setRevealTitle('Reveal');
    } else if (action === 'Banish FD') {
      playSound('bz');
      updatedBZ = [...myBZ, { ...extraCardModalCard, isFaceDown: true }];
      setExtraDeck(updatedExtraDeck);
      setMyBZ(updatedBZ);

      syncGameState({
        extraDeck: updatedExtraDeck,
        bz: updatedBZ,
        mainDeck,
        hand,
        gy: myGYZ,
        fieldMap,
        roomId,
        playerRole
      });
    } else if (action === 'Banish') {
      playSound('bz');
      updatedBZ = [...myBZ, extraCardModalCard];
      setExtraDeck(updatedExtraDeck);
      setMyBZ(updatedBZ);

      syncGameState({
        extraDeck: updatedExtraDeck,
        bz: updatedBZ,
        mainDeck,
        hand,
        gy: myGYZ,
        fieldMap,
        roomId,
        playerRole
      });
    } else if (action === 'To GY') {
      playSound('bz');
      updatedGY = [...myGYZ, extraCardModalCard];
      setExtraDeck(updatedExtraDeck);
      setMyGYZ(updatedGY);

      syncGameState({
        extraDeck: updatedExtraDeck,
        gy: updatedGY,
        mainDeck,
        hand,
        bz: myBZ,
        fieldMap,
        roomId,
        playerRole
      });
    } else if (action === 'SS ATK') {
      setPendingExtraSummon(extraCardModalCard);
      setExtraSummonPosition('ATK');
    } else if (action === 'SS DEF') {
      setPendingExtraSummon(extraCardModalCard);
      setExtraSummonPosition('DEF');
    } else if (action === 'XYZ Summon') {
      setPendingExtraSummon({ ...extraCardModalCard, xyzMode: true });
      setExtraSummonPosition('ATK'); // or let user pick later
    }

    setExtraCardModalCard(null);
    setViewZoneCards([]); // Closes the Extra Deck viewer
  };



  const handleHandAction = (action) => {
    if (!handMenuCard) return;
    resetAllPendingStates(); // 🧹 clear old pending actions


    if (action === 'To GY') {
      playSound('bz');
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMyGYZ(prev => [...prev, handMenuCard]);
      setHandMenuCard(null);
    } else if (action === 'Banish') {
      playSound('bz');
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMyBZ(prev => [...prev, handMenuCard]);
      setHandMenuCard(null);
    } else if (action === 'SS ATK') {
      setPendingSSATKHand(handMenuCard); // new summon state
      setSummonPosition('ATK');
      setHandMenuCard(null);          // ✅ close overlay
    } else if (action === 'N.Summon') {
      setPendingNormalSummon(handMenuCard); // 🔥 activate N.Summon mode
      setHandMenuCard(null);
    } else if (action === 'SS DEF') {
      setPendingSSDEFHand(handMenuCard); // new summon state
      setSummonPosition('DEF');
      setHandMenuCard(null);
    } else if (action === 'Banish FD') {
      playSound('bz');
      setHand(prev => prev.filter(c => c !== handMenuCard));
      // Add a flag to indicate face-down
      setMyBZ(prev => [
        ...prev,
        {
          ...handMenuCard,
          isFaceDown: true
        }
      ]);
      setHandMenuCard(null);
    } else if (action === 'Declare') {
      setRevealCard(handMenuCard);
      setRevealTitle('Effect Declaration');
      setHandMenuCard(null);
    } else if (action === 'Reveal') {
      setRevealCard(handMenuCard);
      setRevealTitle('Reveal');
      setHandMenuCard(null);
    }
    //   else if (action === 'Activate') {
    //   const cardCopy = { ...handMenuCard };
    //   cardCopy.original = handMenuCard;

    //   setPendingSTPlacement(cardCopy);

    //   setHand(prev => prev.filter(c => c !== handMenuCard));
    //   setHandMenuCard(null);
    // } 
    else if (action === 'To S/T' || action === 'Activate') {
      const cardCopy = {
        ...handMenuCard,
        isFaceDown: action === 'To S/T',
        original: handMenuCard  // ✅ store reference so we can remove it later
      };
      setPendingSTPlacement(cardCopy); // 🕐 card will be placed when clicking on STZ
      setHandMenuCard(null);
    }

    else if (action === 'To Top Deck') {
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMainDeck(prev => [handMenuCard, ...prev]); // ⬆️ Top means unshift
      setHandMenuCard(null);
    }
    else if (action === 'To Bottom deck') {
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMainDeck(prev => [...prev, handMenuCard]); // ⬇️ Bottom means push
      setHandMenuCard(null);
    } else if (action === 'Set S/T') {

      const cardCopy = { ...handMenuCard, isFaceDown: true };
      cardCopy.original = handMenuCard; // ✅ Keep reference to original object
      setPendingSTPlacement(cardCopy);
      setHandMenuCard(null);
    } else if (action === 'Set Monster Zone') {

      const cardCopy = { ...handMenuCard, isFaceDown: true };
      cardCopy.original = handMenuCard;
      setPendingSetMonsterHand(cardCopy); // 🆕 New state
      setSummonPosition('DEF'); // ensure defense
      setHandMenuCard(null);
    } else if (action === 'Set Field' || action === 'Activate Field') {
      const newCard = {
        ...handMenuCard,
        isFaceDown: action === 'Set Field'
      };

      // ✅ Get the old FZ card BEFORE changing anything
      const oldCardToGY = fieldMap['My FZ']?.card || null;

      // ✅ Replace field spell
      setFieldMap(prev => ({
        ...prev,
        'My FZ': {
          card: newCard,
          position: 'FACEUP',
          from: 'hand',
          type: 'Field'
        }
      }));

      // ✅ Safely send the old one to GY
      if (oldCardToGY) {
        setMyGYZ(prev => [...prev, oldCardToGY]);
      }

      // ✅ Remove from hand
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setHandMenuCard(null);
    }


    else {
      setHandMenuCard(null); // just close overlay for others
    }
  };
  const handleCardClickFromZone = (card) => {
    switch (zoneViewerTitle) {
      case 'Extra Deck':
        setExtraCardModalCard(card);
        break;
      case 'Graveyard':
        setZoneCardModal({ card, origin: 'GY' });
        break;
      case 'Banished':
        setZoneCardModal({ card, origin: 'BZ' });
        break;
      case 'Deck':
        setZoneCardModal({ card: { ...card, original: card }, origin: 'Deck' });
        break;
      default:
        break;
    }
  };


  const flipCols = playerRole === 'host';
  const flipRows = playerRole === 'host';
  const renderedGrid = flipCols ? [...logicalGrid].reverse() : logicalGrid;
  return (


    <div className="duel-container">
      {roomStatus !== 'full' && (
        <div className="room-id-banner">
          Room ID: {roomId}
        </div>
      )}

      <div className="opponent-hand">
        <div className="hand-inner">
          {opponentHand.map((_, index) => (
            <img
              key={index}
              src={cardBackImage}
              alt="Face-down card"
              className="hand-card"
            />
          ))}
        </div>
      </div>
      <div className="duel-inner">
        <div className="duel-field-grid">

          {renderedGrid.map((column, colIdx) => (
            <div key={colIdx} className="duel-column">
              {(flipRows ? [...column].reverse() : column).map((logicalLabel, rowIdx) => {
                if (logicalLabel === 'TOKEN_BUTTON') {
                  return (
                    <div
                      key={rowIdx}
                      className="zone"
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        display: 'flex',
                        backgroundColor: '#2c2c2c',
                        color: 'white'
                      }}
                      onClick={() => setPendingToken(true)}
                    >
                      Token
                    </div>
                  );
                }

                // Extract logical parts
                const [owner, rawZone] = logicalLabel.split('.');
                const isMine = playerRole === owner;
                const label = playerRole === 'host'
                  ? (owner === 'host' ? `My ${rawZone}` : `Opp ${rawZone}`)
                  : (owner === 'guest' ? `My ${rawZone}` : `Opp ${rawZone}`);
                const zoneData = (isMine ? fieldMap : opponentFieldMap)[rawZone];


                return (
                  <PvpSlot
                    key={rowIdx}
                    opponentMainDeck={opponentMainDeck}
                    opponentExtraDeck={opponentExtraDeck}
                    label={label} // "My MZ1", "Opp STZ2", etc
                    fieldMap={isMine ? fieldMap : opponentFieldMap}
                    opponentGY={opponentGY}
                    opponentBZ={opponentBZ}
                    opponentFieldMap={opponentFieldMap}
                    zoneData={zoneData} // ✅ safe lookup
                    setFieldMap={setFieldMap}
                    syncGameState={syncGameState}
                    pendingSummon={pendingSummon}
                    setPendingSummon={setPendingSummon}
                    pendingNormalSummon={pendingNormalSummon}
                    setPendingNormalSummon={setPendingNormalSummon}
                    summonPosition={summonPosition}
                    setHand={setHand}
                    myGYZ={myGYZ}
                    myBZ={myBZ}
                    setViewZoneCards={setViewZoneCards}
                    setZoneViewerTitle={setZoneViewerTitle}
                    showDeckMenu={showDeckMenu}
                    setShowDeckMenu={setShowDeckMenu}
                    mainDeck={mainDeck}
                    setMainDeck={setMainDeck}
                    extraDeck={extraDeck}
                    setExtraDeck={setExtraDeck}
                    setShowExtraMenu={setShowExtraMenu}
                    pendingExtraSummon={pendingExtraSummon}
                    setPendingExtraSummon={setPendingExtraSummon}
                    extraSummonPosition={extraSummonPosition}
                    setSelectedCard={setSelectedCard}
                    pendingFieldMove={pendingFieldMove}
                    setPendingFieldMove={setPendingFieldMove}
                    pendingFieldPlacement={pendingFieldPlacement}
                    setPendingFieldPlacement={setPendingFieldPlacement}
                    setMyGYZ={setMyGYZ}
                    setMyBZ={setMyBZ}
                    pendingOverlay={pendingOverlay}
                    setPendingOverlay={setPendingOverlay}
                    pendingSSATKHand={pendingSSATKHand}
                    setPendingSSATKHand={setPendingSSATKHand}
                    pendingSSDEFHand={pendingSSDEFHand}
                    setPendingSSDEFHand={setPendingSSDEFHand}
                    pendingSetMonsterHand={pendingSetMonsterHand}
                    setPendingSetMonsterHand={setPendingSetMonsterHand}
                    pendingSTPlacement={pendingSTPlacement}
                    setPendingSTPlacement={setPendingSTPlacement}
                    pendingToken={pendingToken}
                    setPendingToken={setPendingToken}
                    roomId={roomId}
                    playerRole={playerRole}
                    db={db}
                    hand={hand}

                  />
                );
              })}
            </div>
          ))}

        </div>


        <div className="hand-bar">
          <div className="hand-inner">
            {hand.map((card, index) => (
              <HandCard
                key={card.id + '-' + index}
                card={card}
                onClick={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  setHandMenuCard(card);
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <AllModals
        handMenuCard={handMenuCard}
        setHandMenuCard={setHandMenuCard}
        showDeckMenu={showDeckMenu}
        setShowDeckMenu={setShowDeckMenu}
        onDeckAction={onDeckAction}
        showExtraMenu={showExtraMenu}
        setShowExtraMenu={setShowExtraMenu}
        onExtraDeckAction={handleExtraDeckAction}
        zoneCardModal={zoneCardModal}
        setZoneCardModal={setZoneCardModal}
        onZoneCardAction={handleZoneCardAction}
        fieldCard={selectedCard}
        setFieldCard={setSelectedCard}
        onFieldCardAction={handleFieldCardAction}
        extraCardModalCard={extraCardModalCard}
        setExtraCardModalCard={setExtraCardModalCard}
        onExtraCardAction={handleExtraCardAction}
        revealCard={revealCard}
        revealTitle={revealTitle}
        setRevealCard={setRevealCard}
        showDeckModal={showDeckModal}
        setShowDeckModal={setShowDeckModal}
        mainDeck={mainDeck}
        viewZoneCards={viewZoneCards}
        setViewZoneCards={setViewZoneCards}
        zoneViewerTitle={zoneViewerTitle}
        onCardClickFromZone={handleCardClickFromZone}
        onHandAction={handleHandAction}
      />





    </div>
  );
};

export default PvpOnline;
